import { motion } from "framer-motion";
import DecorativeDivider from "@/components/DecorativeDivider";
import heroImage from "@/assets/hero.jpg";

const HERO_IMAGE = heroImage;

export default function HeroSection() {
  return (
    <section
      className="min-h-[85vh] flex items-center py-10 sm:py-14 md:py-16"
      data-testid="hero-section"
    >
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="order-1 md:order-1"
          >
            <div className="photo-frame rounded-2xl overflow-hidden shadow-sm max-w-[280px] sm:max-w-xs md:max-w-sm lg:max-w-md mx-auto md:mx-0">
              <img
                src={HERO_IMAGE}
                alt="Nishad Ramnath Dangui"
                className="w-full h-auto object-cover aspect-[3/4]"
                style={{ pointerEvents: "none" }}
                draggable="false"
              />
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="order-2 md:order-2 text-left"
          >
            <p
              className="text-xs sm:text-sm tracking-[0.2em] uppercase mb-2 sm:mb-3 font-semibold"
              style={{ color: "#8A9A5B", fontFamily: "'Manrope', sans-serif" }}
            >
              Get to know
            </p>

            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium mb-3 sm:mb-4 tracking-tight leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", color: "#2D2D2A" }}
            >
              Nishad Ramnath
              <br />
              Dangui
            </h1>

            <p
              className="text-sm sm:text-base md:text-lg mb-4 sm:mb-6 font-medium"
              style={{ color: "#8A9A5B", fontFamily: "'Manrope', sans-serif" }}
            >
              Senior Software Engineer &middot; Family-Oriented &middot; Grounded & Ambitious
            </p>

            <p
              className="text-sm sm:text-base md:text-lg leading-relaxed font-light mb-6 sm:mb-8"
              style={{ color: "#2D2D2A", fontFamily: "'Manrope', sans-serif", opacity: 0.85 }}
            >
              I come from a culturally rooted and respectful family background. Professionally settled and growth-oriented, I value stability, integrity, and meaningful relationships.
            </p>

            <DecorativeDivider />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
